import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchPrivacyCollection = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-data-collection/${subscriberGroupId}`);
    return res?.data?.data?.data_collection_text ?? "";
};

export const usePrivacyCollection = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["privacyCollection", subscriberGroupId],
        queryFn: () => fetchPrivacyCollection(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        privacyCollectionNotice: data ?? "",
        isLoading,
    };
};
